import "./metrology.css"
import React, { useState, useCallback, useEffect } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleChevronLeft, faCircleChevronRight, faCircleXmark } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom"
import logoMetrology from "../../imagens/logos/logoMetrology.png"

function Metrology({ listaMetrology }) {
    const [slideNumber, setSlideNumber] = useState(0)
    const [openModal, setOpenModal] = useState(false)

    const handleOpenModal = (index) => {
        setSlideNumber(index)
        setOpenModal(true)
    }

    const handleCloseModal = () => {
        setOpenModal(false)
    }


    const prevSlide = useCallback(() => {
        slideNumber === 0 ?
            setSlideNumber(listaMetrology.length - 1) :
            setSlideNumber(slideNumber - 1)
    }, [slideNumber, listaMetrology.length])

    const nextSlide = useCallback(() => {
        slideNumber + 1 === listaMetrology.length ?
            setSlideNumber(0) :
            setSlideNumber(slideNumber + 1)

    }, [slideNumber, listaMetrology.length])
    
    useEffect(() => {
        const handleKeyDown = (event) => {
            switch (event.key) {
                case 'Escape':
                    handleCloseModal()
                    break
                case 'ArrowLeft':
                    prevSlide()
                    break;
                case 'ArrowRight':
                    nextSlide()
                    break;
                default:
                    break;
            }
        };

        if (openModal) {
            window.addEventListener('keydown', handleKeyDown);
        }

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [openModal, nextSlide, prevSlide]);


    return (
        <div>
            {
                openModal &&
                <div className='metrologySliderWrap'>
                    <FontAwesomeIcon icon={faCircleChevronLeft} className="metrologyBtnPrev" onClick={() => prevSlide()} />
                    <FontAwesomeIcon icon={faCircleChevronRight} className="metrologyBtnNext" onClick={() => nextSlide()} />
                    <FontAwesomeIcon icon={faCircleXmark} className="metrologyBtnClose" onClick={() => handleCloseModal()} />
                    <img className='metrologyFullScreenImage' src={listaMetrology[slideNumber].img} alt='metrologyIMG' />
                </div>
            }
            <div>
                <img className='img-custom-size img-fluid ms-2' src={logoMetrology} alt='logoMetrology' />
            </div>
            <div className="metrologyGalleryWrap mx-2">
                {
                    listaMetrology && listaMetrology.map((image, index) => {
                        return (
                            <div
                                className="metrologySingle"
                                key={index}
                                onClick={() => handleOpenModal(index)}
                            >
                                <img src={image.img} alt="metrology"/>

                            </div>
                        )
                    })
                }
            </div>
            <div className="text-center text-nowrap my-4">
                <Link to="/Capabilities/Production">
                    <button className="buttonCapabilities">Back to Production Capabilities</button>
                </Link>
            </div>


        </div>
    )
}

export default Metrology